import { render } from "./AposButton.vue?vue&type=template&id=3de31a10&scoped=true"
import script from "./AposButton.vue?vue&type=script&lang=js"
export * from "./AposButton.vue?vue&type=script&lang=js"

import "./AposButton.vue?vue&type=style&index=0&id=3de31a10&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de31a10"],['__file',"ui/ui/apos/components/AposButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3de31a10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3de31a10', __exports__)) {
    api.reload('3de31a10', __exports__)
  }
  
  module.hot.accept("./AposButton.vue?vue&type=template&id=3de31a10&scoped=true", () => {
    api.rerender('3de31a10', render)
  })

}


export default __exports__